"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.ProductCardHeader = void 0;
require("./ProductCardHeader.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Tag = _interopRequireDefault(require("../Tag/Tag"));
var _Text = _interopRequireDefault(require("../Text/Text"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * ProductCardHeader component
 *
 * @method
 * @param { ProductCardHeaderProps} props
 * @returns ProductCardHeader
 */

const ProductCardHeader = props => {
  const {
    badge,
    externalMediaElement,
    headerBackgroundColor = defaultProps.headerBackgroundColor,
    headerPadding,
    tagsTop,
    theme = defaultProps.theme,
    variantLabel
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-ProductCardHeader', {
    [`pal-c-ProductCardHeader__padding--${headerPadding}`]: headerPadding
  });
  const componentImageClass = (0, _classnames.default)('pal-c-ProductCardHeader__imageContainer', {
    'pal-c-ProductCardHeader__imageContainer--backgroundColor': headerBackgroundColor
  });

  /* using the background color mixin but setting theme to always be default in default props */
  const containerStyle = {
    '--backgroundColor': `var( --pal-colors-${theme}-${headerBackgroundColor} )`
  };
  const hasMedia = !!externalMediaElement;
  const hasTagsArray = tagsTop?.length > 0;
  const hasTags = badge || hasTagsArray;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, hasMedia && /*#__PURE__*/_react.default.createElement("div", {
    className: componentImageClass,
    style: containerStyle
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _renderObject.renderObject)(externalMediaElement), variantLabel && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardHeader__variant"
  }, /*#__PURE__*/_react.default.createElement(_Text.default, {
    htmlTag: "span",
    textColor: "xsubtle",
    textStyle: "label-sm"
  }, variantLabel)))), hasTags && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardHeader__tags"
  }, badge && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardHeader__badge"
  }, /*#__PURE__*/_react.default.createElement(_Tag.default, {
    variant: "default",
    style: "transparent" // eslint-disable-line react/style-prop-object
    ,
    message: badge
  })), hasTagsArray && /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-ProductCardHeader__tagsTop"
  }, tagsTop.map((tagProps, index) => /*#__PURE__*/_react.default.createElement(_Tag.default, _extends({
    key: index
  }, tagProps))))));
};

/**
 * Property type definitions
 * @typedef ProductCardHeaderProps
 * @type {object}
 * @property {string} badge - This is the badge i.e new Arrival, coming soon etc
 * @property {object} externalMediaElement - url, altText, ratio and loading prop for external image or video
 * @property {string} headerBackgroundColor - Sets the backgroundColor of the header
 * @property {array} tagsTop - Accepts array of tags objects to display in the header
 * @property {string} theme - Sets the theme for the backgroundColor
 * @property {string} variantLabel - optional variant text - sits bottom left
 */
exports.ProductCardHeader = ProductCardHeader;
const propTypes = exports.propTypes = {
  /**
   * This is the badge i.e new Arrival, coming soon etc
   */
  badge: _propTypes.default.string,
  /**
   * Allows header prop to accept an object of external media
   */
  externalMediaElement: _propTypes.default.object,
  /**
   * Sets the backgroundColor of the header
   */
  headerBackgroundColor: _propTypes.default.string,
  /**
   * Accepts array of tags objects to display in the header
   */
  tagsTop: _propTypes.default.arrayOf(_propTypes.default.object),
  /**
   * Sets the theme for the backgroundColor
   */
  theme: _propTypes.default.string,
  /**
   * optional variant text - sits bottom left
   */
  variantLabel: _propTypes.default.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} backgroundColor='background-default' - sets the background color
 * @property {string} theme='default' - sets the theme at the component level
 */
const defaultProps = exports.defaultProps = {
  headerBackgroundColor: 'background-default',
  theme: 'default'
};
ProductCardHeader.propTypes = propTypes;
var _default = exports.default = ProductCardHeader;